<template>
    <div>
      <div class="echart-box">
        <div class="map-box">
          <div id="map_1021"></div>
          <div class="info legend">
            <div class="switch-item switch-title" style="padding-top: 5px">
              <span @click="showLegend_1021 = true">图例</span>
              <i v-show="showLegend_1021" @click="showLegend_1021 = false" class="el-icon-close"></i>
            </div>
            <div v-show="showLegend_1021">
              <p class="tip-name" v-for="(item) in levelArr_1021" v-show="item.value == '1021'" :key="item.label">{{item.label}}</p>
              <div class="tip-item" v-for="(item, colorIndex) in data_1021.color" :key="colorIndex">
                <div @click="tableClicks_1021(item.color)" style="display: flex;"
                  :class="clicklayers_1021.indexOf(item.color) == -1 ? '' : 'clicks'">
                  <i class="tip-icon" :style="'background:' + item.color" style="width: 20px; height: 20px; border: black; margin-right: 5px;"></i>
                  <div style="line-height: 20px;" class="tuli">
                    {{ item.qujian }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    
    <script>
    import * as L from 'leaflet' // 引入leaflet插件
    import 'leaflet/dist/leaflet.css' // 引用css样式
    import {getdatasbyid} from '../../api/unicomData'
    var map_1021 = null
    var geohash = require('ngeohash');
    export default {
      data(){
        return{
          id: '',
          activeName: '1021',
          test: ['wxnufuq',],
          // 1021
          data_1021: {},
          data_1021wg: '',
          mapWg_1021: [],
          wgArr_1021: [],
          color_1021: [],
          levelArr_1021: [{
            label: '人数',
            value: '1021'
          }, {
            label: '等级1',
            value: '1'
          }, {
            label: '等级2',
            value: '2'
          }, {
            label: '等级3',
            value: '3'
          }, {
            label: '等级4',
            value: '4'
          }, {
            label: '等级5',
            value: '5'
          }],
          showLegend_1021: true,
          clicklayers_1021: [],
          map_1021: null,
        }
      },
      methods: {
        // 获取地图数据
        getData(){
          this.clicklayers_1021 = this.$options.data().clicklayers_1021
          let params = {
            id: this.id
          }
          getdatasbyid(params).then((res) => {
            let that = this
            console.log(1111,res);
            if (res.errno === 0) {
              // 1021
              if (res.data.result.data[1021].length != 0) {
                if (that.mapWg_1021.length > 0) {
                  for (let i = 0; i < that.mapWg_1021.length; i++) {
                    that.map_1021.removeLayer(that.mapWg_1021[i])
                  }
                }
                // 颜色数组
                this.color_1021 = []
                this.color_1021 = res.data.qujian[1021]
                this.color_1021[0].color = '#5082a4'
                this.color_1021[1].color = '#8eb7a9'
                this.color_1021[2].color = '#dfb96e'
                this.color_1021[3].color = '#d08e46'
                this.color_1021[4].color = '#ff6750'
    
                var list = []
                for (let i = 0; i < res.data.result.data[1021].length; i++) {
                  var decodData = []
                  decodData = (geohash.decode_bbox(res.data.result.data[1021][i].co_fnid))
    
                  // 颜色处理
                  var color = ''
                  if (res.data.result.data[1021][i].popu_value >= res.data.qujian[1021][0].min && res.data.result.data[1021][i].popu_value < res.data.qujian[1021][0].max) {
                    color = '#5082a4'
                  } else if (res.data.result.data[1021][i].popu_value >= res.data.qujian[1021][1].min && res.data.result.data[1021][i].popu_value < res.data.qujian[1021][1].max) {
                    color = '#8eb7a9'
                  } else if (res.data.result.data[1021][i].popu_value >= res.data.qujian[1021][2].min && res.data.result.data[1021][i].popu_value < res.data.qujian[1021][2].max) {
                    color = '#dfb96e'
                  } else if (res.data.result.data[1021][i].popu_value >= res.data.qujian[1021][3].min && res.data.result.data[1021][i].popu_value < res.data.qujian[1021][3].max) {
                    color = '#d08e46'
                  } else if (res.data.result.data[1021][i].popu_value >= res.data.qujian[1021][4].min) {
                    color = '#ff6750'
                  }
                  list.push({
                    geom: { coordinates:[[[ [decodData[1], decodData[0]], 
                                          [decodData[3], decodData[0]], 
                                          [decodData[3], decodData[2]],
                                          [decodData[1], decodData[2]],
                                          [decodData[1], decodData[0]]
                                        ]]],
                            type: "MultiPolygon",
                          },
                    popu_value: res.data.result.data[1021][i].popu_value,
                    od_type: res.data.result.data[1021][i].od_type,
                    color: color
    
                  })
                }
                this.data_1021 = {
                  list: list,
                  color: this.color_1021
                }
                console.log('data_1021',this.data_1021);
    
                var obj = {
                  type: 'FeatureCollection',
                  features: []
                }
                this.data_1021.list.forEach(function (item){
                  var obj2 = {
                    type: "Feature",
                    properties: {
                      type: '1021',
                      popu_value: item.popu_value,
                      od_type: item.od_type,
                      color: item.color
                    },
                    geometry: {
                      type: "MultiPolygon",
                      coordinates: item.geom ? item.geom.coordinates : []
                    }
                  }
                  obj.features.push(obj2)
                })
    
                this.data_1021wg = obj
                console.log('data_1021wg',this.data_1021wg);
    
                that.drawLayer_1021()
                // 设置中心
                if (this.data_1021.list.length > 0) {
                  map_1021.setView([this.data_1021.list[100].geom.coordinates[0][0][0][1], this.data_1021.list[100].geom.coordinates[0][0][0][0]], 12)
                }
              }
            } else {
              console.log(res.error);
            }
          })
        },
        //延迟分批次画图，每次画3000个二维数组
        drawLayer_1021() {
          let that = this
          var newArr = []
          that.mapWg_1021 = []
          that.wgArr_1021 = []
          for (let i = 0; i < this.data_1021wg.features.length;) { //注意：这里与for循环不太一样的是，没有i++
            newArr.push(this.data_1021wg.features.slice(i, i += 3000));
          }
    
          for (let i = 0; i < newArr.length; i++) {
            let obj =
            {
              type: 'FeatureCollection',
              features: newArr[i]
            }
            that.wgArr_1021.push(obj)
          }
    
          for (let i = 0; i < that.wgArr_1021.length; i++) {
            var layer = L.geoJSON(that.wgArr_1021[i], {//geojson图层L.geoJSON
              style: function (geoJsonFeature) {
                return {
                  fillColor: geoJsonFeature.properties.color,
                  fillOpacity: 0.5,
                  color: '#fff',
                  weight: .1
                }
              }
            })//绑定地图
            that.mapWg_1021.push(layer)
          }
    
          for (let i = 0; i < that.mapWg_1021.length; i++) {
            setTimeout(function () {
              map_1021.addLayer(that.mapWg_1021[i])
              that.mapWg_1021[i].bringToFront()
              map_1021.eachLayer(function (layer) {
                if (layer.feature) {
                  if (layer.feature.properties.type == '1021') {
                    that.levelArr_1021.forEach(function (item) {
                      if (item.value == '1021') {
                        layer.bindTooltip(
                          function () {
                            console.log('人数' + ':' + layer.feature.properties.popu_value);
                            return '人数' + ':' + layer.feature.properties.popu_value
                          },
                          { sticky: true });
                      }
                    })
                  }
                }
              });
              // that.mapWg_1021[i].bringToBack()
            }, i * 1000)
          }
          // 设置中心
          // if (this.data_1021.list.length > 0) {
          //   map.setView([this.data_1021.list[0].geom.coordinates[0][0][0][1], this.data_1021.list[0].geom.coordinates[0][0][0][0]], 11)
          // }
        },
        // 初始化地图
        mapInit() {
          let that = this;
          //初始化地图 1021
          map_1021 = L.map("map_1021", {
            // center: this.common.autoZoom(this.$store.state.cityname ? this.$store.state.cityname : localStorage.getItem('cityname'), 'center'),
            center: [39.913828,116.404844], //首都
            zoom: 12,
            zoomControl: false,
            scrollWheelZoom: false,
          });
          var url = "http://webrd0{s}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scale=1&style=8";
          // var url = this.$econf[this.$store.state.colorstore].url
          var layer = new L.TileLayer(url, {
            subdomains: "1234",
          });
          map_1021.addLayer(layer);
          //调整zoom位置
          L.control
            .zoom({
              position: "topright",
            })
            .addTo(map_1021);
    
        },
        tableClicks_1021(items) {
          let that = this
          if (items == this.clicklayers_1021[0]) {
            this.clicklayers_1021 = []
            if (that.mapWg_1021.length > 0) {
              for (let i = 0; i < that.mapWg_1021.length; i++) {
                map_1021.removeLayer(that.mapWg_1021[i])
              }
            }
            var obj = {
              type: 'FeatureCollection',
              features: []
            }
            this.data_1021.list.forEach(function (item) {
              var obj2 = {
                type: "Feature",
                properties: {
									type: '1021',
									popu_value: item.popu_value,
									od_type: item.od_type,
									color: item.color
                },
                geometry: {
                  type: "MultiPolygon",
                  coordinates: item.geom ? item.geom.coordinates : []
                }
              }
    
              obj.features.push(obj2)
            })
            this.data_1021wg = obj
            that.drawLayer_1021()
          } else {
            this.clicklayers_1021 = []
            this.clicklayers_1021.push(items)
            if (that.mapWg_1021.length > 0) {
              for (let i = 0; i < that.mapWg_1021.length; i++) {
                map_1021.removeLayer(that.mapWg_1021[i])
              }
            }
            var obj = {
              type: 'FeatureCollection',
              features: []
            }
            this.data_1021.list.forEach(function (item) {
              if (items == item.color) {
                var obj2 = {
                  type: "Feature",
                  properties: {
                    type: '1021',
										popu_value: item.popu_value,
										od_type: item.od_type,
										color: item.color
                  },
                  geometry: {
                    type: "MultiPolygon",
                    coordinates: item.geom ? item.geom.coordinates : []
                  }
                }
                obj.features.push(obj2)
              }
            })
            this.data_1021wg = obj
            that.drawLayer_1021()
          }
        },
      },
      mounted(){
        this.mapInit()
        this.id = this.$route.query.id;
        this.getData()
      }
    }
    </script>
    
    <style scoped>
    #map_1021 {
      width: 100%;
      height: 800px;
      position: relative;
      z-index: 99;
    }
    
    .map-box {
      position: relative;
    }
    
    #map_1021>>>.my-div-icon {
      width: 56px !important;
      text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0;
    }
    
    .control-info {
      position: absolute;
      left: 10px;
      top: 10px;
      z-index: 100;
    }
    
    .switch-control {
      top: 40px;
    }
    
    .control-info>.input-box {
      display: flex;
    }
    
    .switch-box {
      padding: 10px 15px;
      background: #fff;
      width: auto;
      border-radius: 5px;
      margin-top: 10px;
    }
    
    .switch-item {
      font-size: 12px;
      margin-bottom: 6px;
    }
    
    .switch-title {
      font-weight: bold;
    }
    
    .tip-name {
      font-weight: bold;
      margin-bottom: 6px;
      margin-top: 0;
      font-size: 12px;
    }
    
    .info.legend {
      background: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      width: auto;
      position: absolute;
      right: 10px;
      bottom: 10px;
      z-index: 100;
    }
    
    .tip-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      font-size: 12px;
    }
    
    
    .input-box>>>.querySearch {
      width: auto;
    }
    
    #map_1021>>>.inLine {
      background: red;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      border: 1px solid red;
    }
    
    #map_1021>>>.outLine {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 1px solid red;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    #map_1021>>>.marker-cluster-small div,
    #map_1021>>>.marker-cluster-small,
    #map_1021>>>.marker-cluster-medium,
    #map_1021>>>.marker-cluster-medium div,
    #map_1021>>>.marker-cluster-large,
    #map_1021>>>.marker-cluster-large div {
      background: transparent;
    }
    
    #map_1021>>>.marker-cluster span {
      color: transparent;
    }
    
    #map_1021>>>.pop-item {
      margin-bottom: 12px;
      width: 150px;
      font-size: 14px;
    }
    
    #map_1021>>>.leaflet-control-attribution.leaflet-control {
      display: none;
    }
    
    .switch-cq {
      display: flex;
      align-items: center;
    }
    
    .tooltip {
      width: 80px !important;
    }
    
    /*弹窗样式*/
    #map_1021>>>.leaflet-popup {
      width: 800px;
    }
    
    .drawer-map-dw {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    
    .drawer-map-dw>>>.el-drawer__title {
      margin: 0;
    }
    .tuli:hover{
      color: #d3c373;
    }
    .tip-item > div:focus{
      color: #d3c373;
    }
    
    .el-tab-pane{
      padding: 0 20px 0 20px;
    }
    </style>


// WEBPACK FOOTER //
// src/views/unicomData/map1021.vue